export default __webpack_public_path__ + "static/media/Ballroll_00071.e519c067.png";